import React from "react"

import Footer from "./Footer"
import Navbar from "./Navbar"
import "./layout.css"

interface iLayout {
  children?: object
  pageTitle: string
  hideNavbar?: boolean
  hideFooter?: boolean
}

const Layout: React.FC<iLayout> = ({
  children,
  pageTitle,
  hideNavbar,
  hideFooter,
}) => {
  return (
    <section className="xxl:bg-gray-100">
      <section className="xxl:container xxl:mx-auto xxl:bg-white xxl:border-l xxl:border-r">
        {!hideNavbar ? <Navbar pageTitle={pageTitle} /> : <></>}
        <main>{children}</main>
        {!hideFooter ? <Footer /> : <></>}
      </section>
    </section>
  )
}

export default Layout
